import defaultOrderSummary from '#themes/default/default/components/orderSummary/orderSummary.js';

import cPaymentSummary from '#themes/default/web/components/paymentSummary/paymentSummary.js';
import cPriceTable from '#themes/default/web/components/priceTable/priceTable.js';

export default {
	components: {
		cPaymentSummary,
		cPriceTable
	},
	extends: defaultOrderSummary
};
